<template>
  <div>
    <div ref="target">
      <slot name="target"></slot>
    </div>
    <teleport to="body">
      <div ref="content" style="z-index: 1030" v-click-outside="clickedOutside">
        <div v-if="active" class="popover overflow-auto" :class="[size]" :style="{ 'max-height': maxHeight }">
          <div class="popover-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import {createPopper} from "@popperjs/core";

export default {
  name: "PopoverView",
  props: {
    active: Boolean,
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    },
    placement: {
      type: String,
      default: "bottom",
      validator(value) {
        return ["top", "bottom", "left", "right", "top-start", "top-end", "bottom-start", "bottom-end", "left-start", "left-end", "right-start", "right-end"].includes(value);
      }
    }
  },
  data: function() {
    return {
      opening: false,
      targetRect: undefined,
      popper: undefined
    }
  },
  mounted() {
    this.updateTargetRect();
    window.addEventListener("resize", this.updateTargetRect);
    document.addEventListener("scroll", this.scrolled);
    this.popper = createPopper(this.$refs.target, this.$refs.content, {
      placement: this.placement,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 4]
          }
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ["top", "bottom", "left", "right"],
          },
        },
      ]
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateTargetRect);
    document.removeEventListener("scroll", this.scrolled);
  },
  methods: {
    clickedOutside() {
      if (this.active && !this.opening) this.$emit("update:active", false);
    },
    updatePopper() {
      this.popper.state.elements.reference = this.$refs.target;
      this.popper.state.elements.popper = this.$refs.content;
      this.popper.update();
    },
    updateTargetRect() {
      if (this.active) {
        this.targetRect = this.$refs.target?.getBoundingClientRect();
      }
    },
    scrolled() {
      if (this.active) {
        this.updateTargetRect();
      }
    }
  },
  updated() {
    this.updatePopper();
  },
  watch: {
    active() {
      if (this.active) {
        this.opening = true;
        this.updateTargetRect();
        this.$nextTick(function() {
          this.updatePopper();
          setTimeout(() => this.opening = false, 50);
        });
      }
    },
  },
  computed: {
    maxHeight() {
      const top = (this.targetRect?.top ? this.targetRect.top : 0);
      const bottom = (this.targetRect?.bottom ? this.targetRect.bottom : 0);
      return (Math.max(window.innerHeight - bottom, top) - 20) + "px";
    }
  }
}
</script>

<style scoped>

</style>